import { FC, ReactNode } from 'react';
import { PageCard } from './PageCard';
import { SectionLabel } from './SectionLabel';
import { TOKENS } from './tokens';

type Props = {
  label: string;
  subtitle?: string;
  action?: ReactNode;
  minHeight?: number;
  children: ReactNode;
};

// Standard frame for any chart on the dashboard. Replaces the
// `card card-flush bgi-no-repeat ...` Metronic boilerplate with a single
// tokenized component so all charts share the same label style, spacing
// and surface treatment.
export const ChartWrapper: FC<Props> = ({ label, subtitle, action, minHeight = 220, children }) => {
  return (
    <PageCard style={{ minHeight, display: 'flex', flexDirection: 'column' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: TOKENS.spacing.md }}>
        <div>
          <SectionLabel>{label}</SectionLabel>
          {subtitle && (
            <div style={{ fontSize: 12, color: TOKENS.color.muted, marginTop: 2 }}>{subtitle}</div>
          )}
        </div>
        {action}
      </div>
      <div style={{ flex: 1, minHeight: 0 }}>
        {children}
      </div>
    </PageCard>
  );
};
